import React, {useEffect, useState} from 'react'
import {Box, Chip, Typography} from '@mui/material'
import {startOfMonth, subDays, subMonths} from 'date-fns'
import {useLocation} from 'react-router-dom'
import Page from '../../components/Page'
import PageTitle from '../../components/PageTitle'
import Overview from './Overview'
import OverviewCT from './OverviewCT'
import DateRangePicker from '../../components/DateRangePicker'
import useTabParam from '../../hooks/useTabParam'
import palette from '../../../theme/palette'

const TAB_TITLES = {
  '1': "Today's Overview",
  '2': 'Unprocessed Orders',
  '3': 'Realised Revenue',
  '4': 'Overall Shipments',
}

function getDefaultStart() {
  const d = new Date()
  return d.getDate() === 1 ? startOfMonth(subMonths(d, 1)) : startOfMonth(d)
}

export default function Dashboard() {
  const location = useLocation()
  const shipmentType = (location.pathname.includes('/B2B') || location.pathname.includes('/ptl')) ? 'B2B' : 'B2C'
  const [view] = useTabParam('1')
  const [dateRange1, setDateRange1] = useState([{
    startDate: startOfMonth(new Date()),
    endDate:   subDays(new Date(), 1),
    key: 'selection',
  }])

  useEffect(() => {
    setDateRange1([{startDate: getDefaultStart(), endDate: subDays(new Date(), 1), key: 'selection'}])
  }, [])

  const todayRange     = [{startDate: new Date(), endDate: new Date(), key: 'selection'}]
  const showDatePicker = view === '3' || view === '4'
  const title          = TAB_TITLES[view] || 'Dashboard'

  return (
    <Page title=''>
      <PageTitle>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, mb: 2}}>
          <Typography variant='h6' sx={{fontWeight: 800, color: palette.grey[800], fontSize: '1.15rem'}}>
            {title}
          </Typography>
          <Chip
            label={shipmentType}
            size='small'
            sx={{
              fontWeight: 700, fontSize: '0.68rem', height: 22,
              backgroundColor: shipmentType === 'B2C' ? palette.primary.lighter : palette.success.lighter,
              color: shipmentType === 'B2C' ? palette.primary.main : palette.success.dark,
            }}
          />
        </Box>
      </PageTitle>

      {/* Content card */}
      <Box sx={{
        backgroundColor: palette.common.white,
        borderRadius: 3,
        border: `1px solid ${palette.grey[300]}`,
        boxShadow: 'none',
        overflow: 'hidden',
      }}>
        {/* Date picker strip — only for Realised Revenue & Overall Shipments */}
        {showDatePicker && (
          <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
            px: 2.5, py: 1,
            backgroundColor: palette.background.neutral,
            borderBottom: `1px solid ${palette.grey[300]}`,
          }}>
            <DateRangePicker defaultRange={dateRange1} onChange={(r) => setDateRange1(r)} />
          </Box>
        )}

        {/* Content area */}
        <Box sx={{backgroundColor: palette.background.default, p: 2.5}}>
          {view === '1' && <OverviewCT dateRange={todayRange} mode='overall_today' shipmentType={shipmentType} />}
          {view === '2' && <Overview />}
          {view === '3' && <OverviewCT dateRange={dateRange1} mode='realised' shipmentType={shipmentType} />}
          {view === '4' && <OverviewCT dateRange={dateRange1} mode='overall' shipmentType={shipmentType} />}
        </Box>
      </Box>
    </Page>
  )
}
